<template>
    <div class="flex flex-col">
        <select
            v-model="day"
            class="border border-gray-300 px-2 py-2.5 text-[16px] focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] focus:outline-none focus:outline-offset-0"
            :class="dayInputClass"
            :disabled="disabled"
        >
            <option
                :key="0"
                :value="0"
            >
                {{ t('dropdownDateInput.day') }}
            </option>
            <option
                v-for="day in dayOptions"
                :key="day.value"
                :value="day.value"
            >
                {{ day.name }}
            </option>
        </select>
        <small
            v-if="showDayError"
            id="day-help"
            class="text-red-600"
            >{{ t('dropdownDateInput.dayRequired') }}</small
        >
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    selectedDay: number
    disabled: boolean
    invalid: boolean
    showErrors: boolean
    dayOptions: { name: string; value: number }[]
}>()

const emit = defineEmits<{
    (e: 'update:selected-day', payload: number)
}>()

const { t } = useI18n({ useScope: 'global' })

// Vue does something to get the value from the options, I think,
// so I'm using the writable computed here to take advantage of that
// Using the raw event makes everything a string
const day = computed({
    get() {
        return props.selectedDay
    },
    set(newValue) {
        emit('update:selected-day', newValue)
    }
})

const showDayError = computed(() => {
    return props.selectedDay === 0 && props.showErrors
})

const dayInputClass = computed(() => {
    if (props.disabled === true) {
        return 'text-gray-500'
    } else if (showDayError.value || props.invalid) {
        return 'border-2 border-red-500'
    } else {
        return ''
    }
})
</script>
